// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609290215/js/" + chunkId + "." + {"44":"9e6f2173","225":"cc595324","481":"e247579a","486":"9ea646ba","770":"bf5d1589"}[chunkId] + ".0.08052668782753136.chunk.js";
};